import { ProjectEvent, ProjectEventType } from '../types/Planner';
import { loadEvents, EVENTS_CHANGED_EVENT } from './EventsService';

const EVENT_TYPE_MAP: Record<string, ProjectEventType> = {
    'pre-wedding': 'rehearsal',
    'traditional': 'ceremony',
    'church': 'ceremony',
    'reception': 'reception',
    'after-party': 'after-party',
    'cocktail': 'cocktail-hour',
    'getting-ready': 'getting-ready',
    'photography': 'photography',
};

// Generic fallback times — only used when an event has no times in the DB.
const DEFAULT_START_BY_TYPE: Record<string, string> = {
    'cocktail':      '13:00',
    'getting-ready': '07:00',
    'photography':   '08:00',
    'rehearsal':     '14:00',
    'civil':         '10:00',
};

const DEFAULT_END_BY_TYPE: Record<string, string> = {
    'cocktail':      '15:00',
    'getting-ready': '10:00',
    'photography':   '17:00',
    'rehearsal':     '17:00',
    'civil':         '12:00',
};

let projectEventsCache: ProjectEvent[] | null = null;

// Bust cache whenever the underlying StoredEvents change
if (typeof window !== 'undefined') {
    window.addEventListener(EVENTS_CHANGED_EVENT, () => { projectEventsCache = null; });
}

export const loadProjectEvents = (): ProjectEvent[] => {
    if (projectEventsCache) return projectEventsCache;
    const stored = loadEvents().filter(e => !e.archived);
    if (stored.length === 0) return [];
    return stored.map((e, idx) => ({
        id: e.id,
        title: e.title,
        type: (EVENT_TYPE_MAP[e.type] ?? 'ceremony') as ProjectEventType,
        date: e.startTime ? e.date : e.date,
        startTime: e.startTime ?? DEFAULT_START_BY_TYPE[e.type] ?? '09:00',
        endTime: e.endTime ?? DEFAULT_END_BY_TYPE[e.type] ?? '17:00',
        location: e.location,
        description: e.description,
        progress: e.progress ?? 0,
        status: 'upcoming' as const,
        guestCount: e.headcount,
        order: idx + 1,
        color: e.eventColor,
        dependsOn: idx > 0 ? [stored[idx - 1].id] : [],
    }));
};

export const saveProjectEvents = (events: ProjectEvent[]): void => {
    projectEventsCache = events;
};

export const invalidateProjectEventsCache = (): void => {
    projectEventsCache = null;
};
